export default __webpack_public_path__ + "static/media/banner-bg-small.f86fb377.png";